export const couponTypeConst = [
  { value: 'Treatment', label: 'Tratamiento' },
  { value: 'Product', label: 'Producto' },
  { value: 'MultipleTreatment', label: 'Múltiples tratamientos' },
  { value: 'MultipleProduct', label: 'Múltiples productos' },
  { value: 'Order', label: 'Orden porcentaje' },
  { value: 'Mix', label: 'Mixto' },
  { value: 'OrderAmount', label: 'Orden monto' },
];

export const couponTypeSingularConst = {
  treatment: 'Treatment',
  product: 'Product',
  multipleTreatment: 'MultipleTreatment',
  multipleProduct: 'MultipleProduct',
  order: 'Order',
  mix: 'Mix',
  orderAmount: 'OrderAmount',
};

export const couponTypeEspConst = {
  treatment: 'Tratamiento',
  product: 'Producto',
  multipleTreatment: 'Múltiples tratamientos',
  multipleProduct: 'Múltiples productos',
  order: 'Orden ',
  mix: 'Mix',
};

export const couponTypeDictionary = {
  Treatment: 'Tratamiento',
  Product: 'Producto',
  MultipleTreatment: 'Múltiples tratamientos',
  MultipleProduct: 'Múltiples productos',
  Order: 'Orden',
  Mix: 'Mixto',
  OrderAmount: 'Orden fija',
};

export const searchFilters = [
  { value: 'coupon.code', label: 'Código' },
  { value: 'coupon.name', label: 'Nombre' },
  { value: 'coupon.product', label: 'Producto' },
];

export const filters = {
  search: true,
  status: true,
  branches: true,
  couponType: true,
};

export const searchInputInitialValues = {
  search: { filter: 'coupon.code' },
  status: '1',
};
